import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { usePortal } from '../contexts/PortalContext';
const EASE = [0.23, 1, 0.32, 1] as const;
interface ContactPortalProps {
  open: boolean;
  onClose: () => void;
}
export function ContactPortal({
  open,
  onClose
}: ContactPortalProps) {
  const {
    activeProject,
    contactPortal,
    notify
  } = usePortal();
  const [writing, setWriting] = useState(false);
  const [message, setMessage] = useState('');
  const [sent, setSent] = useState(false);
  const lead = activeProject.team[0];
  function close() {
    onClose();
    setWriting(false);
    setMessage('');
    setSent(false);
  }
  function send(event: React.FormEvent) {
    event.preventDefault();
    const body = message.trim();
    if (!body) return;
    contactPortal(body);
    setMessage('');
    setSent(true);
    notify('Message sent to Portal');
  }
  return <AnimatePresence data-id="element-51" data-mp="wevsl5gg3yqi">
      {open && <motion.div key="contact" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2,
      ease: EASE
    }} className="fixed inset-0 z-50 flex items-center justify-center bg-ink/50 px-6 py-10" role="dialog" aria-modal="true" aria-label="Contact Portal" data-id="element-52" data-mp="wfx6dhouizbx">
          <motion.div initial={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="w-full max-w-lg border border-ink bg-paper px-7 py-9 sm:px-10" data-id="element-53" data-mp="5blzldixrimw">
            <div className="flex items-start justify-between gap-6" data-id="element-54" data-mp="o8evzinegzlg">
              <p className="label m-0 text-graphite" data-id="element-55" data-mp="o6kfcgj5vtn6">Contact Portal</p>
              <button type="button" onClick={close} aria-label="Close" className="text-mute transition-colors duration-150 ease-out hover:text-ink" data-id="element-56" data-mp="2l2hylrgvr1c9">
                <XIcon className="h-4 w-4" strokeWidth={1.25} data-id="element-57" data-mp="2i15e538j7b0d" />
              </button>
            </div>

            {sent ? <>
                <p className="mt-7 font-display text-3xl leading-none" data-id="element-58" data-mp="2rxrupfttrfwl">Message sent</p>
                <p className="mt-5 max-w-sm font-display text-lg text-charcoal" data-id="element-59" data-mp="2mxvs9l0rzwj5">
                  {lead ? `${lead.name} will come back to you shortly.` : 'Portal will reply shortly.'}
                </p>
                <button type="button" onClick={close} className="label mt-9 border border-ink px-6 py-3.5 transition-colors duration-150 ease-out hover:bg-ink hover:text-paper" data-id="element-60" data-mp="2wxeb1y4y9c9m">
                  Close
                </button>
              </> : <>
                <p className="mt-7 font-display text-3xl leading-tight" data-id="element-61" data-mp="3kk2xmx4wlswk">
                  Need help with this project?
                </p>

                {lead && <div className="mt-8 border-y border-rule py-6" data-id="element-62" data-mp="34t9mv71sq9t">
                    <p className="font-display text-2xl leading-none" data-id="element-63" data-mp="75lihnc0ct5k">{lead.name}</p>
                    <p className="label mt-3 text-mute" data-id="element-64" data-mp="3payklflfscl6">{lead.role}</p>
                  </div>}

                {writing ? <form onSubmit={send} className="mt-8" data-id="element-65" data-mp="3u8hww9ykqfah">
                    <label className="block" data-id="element-66" data-mp="3fl57ub9k5rfc">
                      <span className="label block text-graphite" data-id="element-67" data-mp="3fjc2czaold8x">How can we help?</span>
                      <textarea value={message} onChange={event => setMessage(event.target.value)} rows={4} autoFocus placeholder="Tell us what you need…" className="mt-4 w-full resize-none border-0 border-b border-rule bg-transparent pb-3 font-display text-xl text-ink placeholder:text-mute focus:border-ink focus:outline-none" data-id="element-68" data-mp="3kceynf6uf0st" />
                    </label>
                    <div className="mt-8 flex flex-wrap items-center gap-6" data-id="element-69" data-mp="8sq8eg5v449h">
                      <button type="submit" className="label border border-ink px-6 py-3.5 transition-colors duration-150 ease-out hover:bg-ink hover:text-paper" data-id="element-70" data-mp="3svk8kdh1ss4">
                        Send to Portal
                      </button>
                      <button type="button" onClick={() => setWriting(false)} className="label text-mute transition-colors duration-150 ease-out hover:text-ink" data-id="element-71" data-mp="3l9lpbf5ujxu3">
                        Cancel
                      </button>
                    </div>
                  </form> : <div className="mt-8 flex flex-wrap items-center gap-6" data-id="element-72" data-mp="1aeocci5rdl1z">
                    <button type="button" onClick={() => setWriting(true)} className="label border border-ink px-6 py-3.5 transition-colors duration-150 ease-out hover:bg-ink hover:text-paper" data-id="element-73" data-mp="15gmrbrorvbnv">
                      Send Message
                    </button>
                    <button type="button" onClick={() => notify('Simulated · would open your email client')} className="label text-mute transition-colors duration-150 ease-out hover:text-ink" data-id="element-74" data-mp="1mr0dcdzhej4l">
                      Email Portal
                    </button>
                  </div>}
              </>}
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}